import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash';
import {
	compose,
	withHandlers,
	defaultProps
} from 'recompose';

import { Checkmark } from 'components/svg';
import { Text } from 'components/core/Text';

const enhance = compose(
	defaultProps({
		onToggleSearchOnMove: noop
	}),
	withHandlers({
		handleToggleSearchOnMove: ({ onToggleSearchOnMove }) => () => {
			onToggleSearchOnMove();
		}
	})
);

export function SearchOnMove({ searchOnMove, handleToggleSearchOnMove }) {
	return (
		<button
			type="button"
			className="search-on-move-container"
			onClick={handleToggleSearchOnMove}
		>
			<span className={classnames('checkbox', { checked: searchOnMove })}>
				<Checkmark />
			</span>
			<Text>Search when I move the map</Text>
		</button>
	);
}

SearchOnMove.propTypes = {
	handleToggleSearchOnMove: PropTypes.func,
	searchOnMove: PropTypes.bool
};

export default enhance(SearchOnMove);
